<script setup lang="ts">
import { useI18n } from 'petite-vue-i18n';
import { TEXT } from '../../../../configs/text';
import { useQuizStore, useSessionStore, useSignalRStore } from '../../../../stores';
import { Session } from '../../../../types/session';
import { computed, ref } from 'vue';
import Button from '../../../General/Button.vue';
import { EyeIcon } from '@heroicons/vue/24/outline';
import Modal from '../../../General/Modal.vue';
import Iframe from '../../../General/Iframe.vue';

const signalr = useSignalRStore()
const sessionStore = useSessionStore()
const quizStore = useQuizStore()
const modalShow = ref<boolean>(false)

const quizUrl = ref<string>(quizStore.quiz.url)
const isQuizStarted = computed<boolean>(() => {
    return sessionStore.practiceQuizState?.[Session.quiz] || false
})

function handleSaveQuiz(e: Event) {
    e.preventDefault()
    signalr.updateQuizUrl(quizUrl.value)
}

function handleToggleQuiz() {
    if (isQuizStarted.value) {
        signalr.stopQuiz()
        return
    }

    signalr.startQuiz()
}

const { t } = useI18n()
</script>

<template>
    <div class="h-full overflow-auto py-3 md:py-14 px-3 md:px-14 lg:px-44">
        <div class="font-bold">{{ t(TEXT.instruction) }}</div>
        <div class="mb-5">{{ t(TEXT.quiz_instruction) }}</div>

        <div class="font-bold">{{ t(TEXT.supported_systems) }}</div>
        <div class="mb-8 md:mb-16">{{ t(TEXT.quiz_supported_systems) }}</div>

        <div class="font-bold">
            {{ t(TEXT.student) }}
            <EyeIcon class="inline size-5 text-gray-500 ml-1 cursor-pointer" @click="modalShow = true" />
        </div>
        <form @submit="handleSaveQuiz" class="flex flex-col md:flex-row items-stretch gap-3 mb-10 md:mb-32">
            <input v-model="quizUrl" :placeholder="t(TEXT.enter_student_quiz_link)"
                class="w-full max-w-3xl outline-none block rounded-full border-0 py-2 px-4 text-gray-600 ring-2 ring-inset ring-gray-300 placeholder:text-gray-600 focus:ring-2 focus:ring-inset focus:ring-orange-600" />
            <Button color="warning" class="shrink-0">
                {{ t(TEXT.save) }}
            </Button>
        </form>

        <Button color="warning" class="mx-auto" @click="handleToggleQuiz" :submit="false">
            {{ t(isQuizStarted ? TEXT.hide_quiz : TEXT.show_quiz) }}
        </Button>

        <Modal v-model="modalShow" size="full" :full-height="true">
            <Iframe :src="quizUrl" orientation="full" />
        </Modal>
    </div>
</template>